import { render } from "./ArchivedAlerts.vue?vue&type=template&id=3e8f56d6&ts=true"
import script from "./ArchivedAlerts.vue?vue&type=script&lang=ts"
export * from "./ArchivedAlerts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__